import styled from 'styled-components';

interface IInputStyled {
	filled: boolean;
	error: boolean;
}
interface IDivAsLink {
	disabled: boolean;
}

export const PageConnectFooterControl = styled.div`
	position: absolute;
	bottom: 80px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	left: 0;
	flex-direction: column;
	box-sizing: border-box;
	padding: 16px;
`;
export const PageConnectFooterText = styled.span`
	color: ${({ theme }) => theme.color.abbey};
	font-size: 12px;
`;

export const InputStyled = styled.input<IInputStyled>`
	width: 100%;
	height: 64px;
	background: ${({ theme, filled, error }) => (error ? theme.color.wePeep : filled ? theme.color.linkWater : theme.color.porcelainSecond)};
	color: ${({ theme, error }) => (error ? theme.color.cerise : theme.color.endeavour)};
	border-radius: 2px;
	text-align: center;
	font-size: 32px;
	border: none;
	box-shadow: none;
	letter-spacing: 20px;
	text-indent: 20px;
`;

export const InputContainer = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;
export const DivAsLink = styled.div<IDivAsLink>`
	color: ${({ theme, disabled }) => disabled? theme.color.casper : theme.color.endeavour};
	display: inherit;
	cursor: ${({ disabled }) => disabled? 'not-allowed': 'pointer'};
`;
